export default __webpack_public_path__ + "static/media/01_motorova-pila.22062657.jpg";